"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _OutboundLink = _interopRequireDefault(require("../../../../atoms/OutboundLink"));

var ServicesBody = function ServicesBody(props) {
  var services = props.services,
      bodyColor = props.bodyColor;
  var serviceLength = services.length;
  var spaceColumns = Math.floor((16 - 2 - serviceLength * 4) / (serviceLength - 1));
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
    style: {
      paddingBottom: '3em',
      paddingTop: '3em',
      backgroundColor: bodyColor
    },
    centered: true
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 1,
    only: "computer"
  }), services.map(function (service, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "footer-service-".concat(service.title)
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      tablet: 2,
      only: "tablet"
    }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      computer: 4,
      tablet: 12
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        textAlign: 'center',
        fontSize: '1.3em',
        fontWeight: 'bold',
        paddingBottom: '.5em'
      }
    }, /*#__PURE__*/_react["default"].createElement(_OutboundLink["default"], {
      to: service.link,
      label: service.title
    })), /*#__PURE__*/_react["default"].createElement("div", null, service.content)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      tablet: 2,
      only: "tablet"
    }), index !== serviceLength - 1 ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      computer: spaceColumns,
      only: "computer"
    }) : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      computer: 1,
      only: "computer"
    }));
  }));
};

ServicesBody.propTypes = {
  bodyColor: _propTypes["default"].string.isRequired
};
var _default = ServicesBody;
exports["default"] = _default;